var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { jsxs, jsx } from "react/jsx-runtime";
import { registerIcons } from "@ane/ui-components/lib/Styling";
import { fontFace } from "@fluentui/merge-styles";
const registerCustomIcons = () => __async(void 0, null, function* () {
  const fontURL = (yield import("../fonts/custom-icons.woff")).default;
  fontFace({
    fontFamily: "MDLAssets",
    src: `url('${fontURL}') format('woff')`
  });
  registerIcons({
    fontFace: {
      fontFamily: `"MDLAssets"`
    },
    icons: {
      DatabaseSource: "",
      DataFlow: "",
      StackedBarChartFull: "",
      ArchiveUndo: "",
      BarChart3: "",
      BarChart3Two: "",
      BarChart3One: "",
      BarChart3Zero: "",
      ControlTower: /* @__PURE__ */ jsxs("svg", { width: "40px", height: "40px", viewBox: "0 0 264 264", version: "1.1", children: [
        /* @__PURE__ */ jsx("defs", {}),
        /* @__PURE__ */ jsx("g", { stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd", children: /* @__PURE__ */ jsx("g", { id: "Control-tower-logo", transform: "translate(-152.000000, -49.000000)", children: /* @__PURE__ */ jsx("g", { id: "Group-2", transform: "translate(156.000000, 53.000000)", children: /* @__PURE__ */ jsxs("g", { id: "Group", children: [
          /* @__PURE__ */ jsx("circle", { id: "Oval", stroke: "#FFFFFF", "stroke-width": "7", cx: "128", cy: "128", r: "128" }),
          /* @__PURE__ */ jsx("g", { id: "black-plane", transform: "translate(60.952381, 51.200000)", fill: "#FFFFFF", "fill-rule": "nonzero", children: /* @__PURE__ */ jsx(
            "path",
            {
              d: "M160.914286,76.8 C160.914286,70.3326316 155.282286,64.6736842 148.845714,64.6736842 L104.594286,64.6736842 L64.3657143,0 L48.2742857,0 L68.3885714,64.6736842 L24.1371429,64.6736842 L12.0685714,48.5052632 L0,48.5052632 L8.04571429,76.8 L0,105.094737 L12.0685714,105.094737 L24.1371429,88.9263158 L68.3885714,88.9263158 L48.2742857,153.6 L64.3657143,153.6 L104.594286,88.9263158 L148.845714,88.9263158 C155.282286,88.9263158 160.914286,83.2673684 160.914286,76.8 Z",
              id: "Shape"
            }
          ) })
        ] }) }) }) })
      ] })
    }
  });
});
export {
  registerCustomIcons
};
//# sourceMappingURL=fonts.js.map
